import {createSelector} from 'reselect'
import {AppState} from 'redux/config'

export const select_toasts = (state: AppState) => state.toast.toasts

export const select_toasts_areDisplayable = createSelector(
  select_toasts,
  toasts => toasts.length > 0
)

export const select_toasts_last = createSelector(
  select_toasts,
  toasts => toasts.length > 0
    ? toasts[toasts.length - 1]
    : null
)
